import React from 'react';
import { Box, Flex, Image, Text, Icon, VStack, HStack } from '@chakra-ui/react';
import webApp from '@happylife-a/web-app';
import webCore from '@happylife-a/web-core';
import utils from '@happylife-a/utils';

const statusColors = {
  Booked: {
    backgroundColor: 'green.50',
    textColor: 'green.500',
  },
  draft: {
    backgroundColor: 'gray.50',
    textColor: 'gray.800',
  },
  Canceled: {
    backgroundColor: 'red.50',
    textColor: 'red.500',
  },
};

export default function BookingCard({
  title,
  description,
  image,
  dateFrom,
  dateTo,
  status,
  price,
}) {
  const { t } = webCore.contexts.useTranslation();

  const colorsStatus = statusColors[status] || {
    backgroundColor: 'gray.50',
    textColor: 'gray.800',
  };
  return (
    <Flex
      p={4}
      borderWidth="1px"
      borderRadius="md"
      boxShadow="sm"
      bg="white"
      w="full"
      gap={4}
      alignItems={{ base: 'flex-start', md: 'center' }}
      flexDir={{ base: 'column', md: 'row' }}
    >
      <Image src={image} alt={title} objectFit="cover" borderRadius="md" boxSize="150px" />

      <Flex flex="1" direction="column" justify="center">
        <Text variant="title-semi">{title}</Text>
        <Text variant="sub-head-reg" mt={1} color="gray.500">
          {description}
        </Text>

        <HStack spacing={2} mt={3} color="gray.500" fontSize="md">
          <Icon as={webApp.theme.icons.BookingHistory} w={6} h={6} fill="none" />
          <Box
            px={2}
            py={1}
            borderRadius="8px"
            alignSelf="flex-start"
            bgColor={colorsStatus.backgroundColor}
          >
            <Text variant="body-reg-md" color={colorsStatus.textColor}>
              {t(status)}
            </Text>
          </Box>
        </HStack>
        <HStack>
          <Text variant="body-reg-md">
            {dateFrom} - {dateTo}
          </Text>
        </HStack>
      </Flex>

      <VStack align={{ base: 'start', md: 'end' }} spacing={3}>
        <Text variant="sub-head-semi" color="primary.500">
          {utils.helpers.currency.beautify(price)}
        </Text>
      </VStack>
    </Flex>
  );
}
